export enum NotaAvaliacao {
	INACEITAVEL = 1,
	INSATISFATORIO = 2,
	INDUSTRIAS = 3,
	OUTRO = 4,
	EXCELENTE = 5
}